import React from 'react';
import { Checkbox as MuiCheckbox, CheckboxProps as MuiCheckboxProps } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { OverridableComponent } from '@mui/material/OverridableComponent';

const useStyles = makeStyles()(() => ({
  root: {
    '&.dense': {
      padding: 0,
    },
  },
}));

interface CheckboxProps extends MuiCheckboxProps {
  dense?: boolean;
}

type TypeMap<D extends React.ElementType = 'li'> = {
  props: CheckboxProps;
  defaultComponent: D;
  classKey: string;
};

const Checkbox: React.FC<React.PropsWithChildren<CheckboxProps>> = (props) => {
  const { className, dense } = props;
  const { classes, cx } = useStyles();

  return <MuiCheckbox {...(props as any)} className={cx(className, { dense })} classes={classes} />;
};

export default Checkbox as OverridableComponent<TypeMap>;
